import {PlayerBrowseResponse} from './api';
import {PlayerBrowseState} from './types';

export function updateWatchlistBrowseData(
  data: PlayerBrowseResponse | undefined,
  state: PlayerBrowseState,
  playerId: string,
  isWatched: boolean,
): PlayerBrowseResponse | undefined {
  if (!data) return undefined;
  const index = data.data.findIndex(player => player.id === playerId);
  if (index === -1) return data;

  if (state.watching && !isWatched) {
    const total = Math.max(0, data.meta.total - 1);
    return {
      ...data,
      data: data.data.filter(player => player.id !== playerId),
      meta: {...data.meta, total, totalPages: Math.ceil(total / data.meta.pageSize)},
    };
  }

  const current = data.data[index];
  if (current.isWatched === isWatched) return data;
  const players = [...data.data];
  players[index] = {...current, isWatched};
  return {...data, data: players};
}
